<template>
  <div class="device-manage-log">
    <app-query-bar
      :queryConfig="queryConfig"
      v-model="queryData"
      @onSearch="fetchLogs" />
    <app-export-bar
      @onExport="onExport"
      @onExportAll="onExportAll" />
    <app-data-table
      :columns="LOG_COLUMNS"
      :data="logs"
      v-model="queryData"
      @onPageConfigChange="fetchLogs">
      <template
        slot-scope="{ row }"
        slot="type">
        {{ BASIC_OPERATION_TYPE_TEXT[row.type] }}
      </template>
    </app-data-table>
  </div>
</template>

<script>
import {
  LOG_COLUMNS,
  BASIC_OPERATION_TYPE_TEXT,
  OPERATION_TYPE,
  OPERATION_TYPE_OPTIONS,
} from './constants';
import DeviceManageLogApi from './device-manage-log.api';
import DataTransferUtil from '@/utils/data-transfer.util';

export default {
  name: 'device-manage-log',
  data() {
    return {
      LOG_COLUMNS,
      BASIC_OPERATION_TYPE_TEXT,
      queryConfig: [
        {
          fieldName: 'type',
          name: '操作类型',
          type: 'select',
          options: OPERATION_TYPE_OPTIONS,
        },
        {
          fieldName: 'optNickName',
          name: '操作人',
        },
        // {
        //   fieldName: 'productNo',
        //   name: '设备编号',
        // },
        {
          fieldName: 'produceNo',
          name: '生产编号',
        },
      ],
      queryData: {
        page: 1,
        limit: 10,
        count: 0,
        type: OPERATION_TYPE.ALL,
        optNickName: '',
        productNo: '',
        produceNo: '',
      },
      logs: [],
    };
  },
  created() {
    this.fetchLogs();
  },
  methods: {
    async fetchLogs() {
      const {
        page,
        limit,
        type,
        optNickName,
        productNo,
        produceNo,
      } = this.queryData;
      const {
        count = 0,
        results = [],
      } = await DeviceManageLogApi.getLogs(
        page,
        limit,
        type,
        productNo,
        produceNo,
        optNickName,
      );
      this.logs = results;
      this.$set(this.queryData, 'count', count);
    },
    async onExport() {
      const {
        page,
        limit,
        type,
        optNickName,
        productNo,
        produceNo,
      } = this.queryData;
      const key = await DeviceManageLogApi.export({
        page,
        limit,
        type,
        product_no: productNo,
        produce_no: produceNo,
        opt_nick_name: optNickName,
      });
      await DataTransferUtil.downloadFileBySecretKey(key);
    },
    async  onExportAll() {
      const key = await DeviceManageLogApi.export();
      await DataTransferUtil.downloadFileBySecretKey(key);
    },
  },
};
</script>

<style scoped>

</style>
